import type { RequestStateStatus } from 'redux/shared/request/types'

export const isLoadingStatus = (status: RequestStateStatus): boolean =>
  status === 'loading'
